import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Resizable } from '../Resizable';
const ResizableTitle = (props) => {
    const initWidth = useRef(0);
    const { onResize, width, children, ...restProps } = props;
    if (!initWidth.current) {
        initWidth.current = width;
    }
    if (!width) {
        return _jsx("th", { ...restProps, children: children });
    }
    return (_jsx("th", { ...restProps, children: _jsx(Resizable, { range: { MIN: initWidth.current, MAX: 500 }, onResize: (_, __, _el) => {
                onResize(_el.style.width);
            }, children: children }) }));
};
export default ResizableTitle;
